import { useQuery } from "convex/react";
import { api } from "$convex/convexApi";
import { useAuthIdentity } from "@/contexts/UserProfileContext";

export function useUsersForImpersonation() {
  const { authUserId } = useAuthIdentity();
  return useQuery(
    api.sales.getAllUsersForImpersonation,
    authUserId ? { authUserId } : "skip",
  );
}

export function useMyProfile() {
  return useQuery(api.users.getMyProfile);
}

export function useUser(userId?: string) {
  return useQuery(api.users.getUser, userId ? { userId } : "skip");
}
